import { createSlice } from '@reduxjs/toolkit';
import { ThunkDispatch as Dispatch } from 'redux-thunk';
import { getPaymentUserList } from '../../../services/api-ssrr/CollectionManagerAPIClient';
import { UserState } from '../../../types-interfaces/interfaces';
import { RootState } from '../../store';

const initialState = {
    loading: false,
    paymentUsers: [{ value: '', name: ''}],
    error: {}
}

export const PaymentUserSlice = createSlice({
    name: 'paymentUser',
    initialState,
    reducers: {
        init: (state) => {
            state.loading = true
        },
        paymentUsers: (state, { payload }) => {
            state.loading = false
            state.paymentUsers = payload
        },
        failure: (state, { payload }) => {
            state.error = payload
        }
    }
});

export const { init, paymentUsers, failure } = PaymentUserSlice.actions;
export const selectPaymentUsers = (state: RootState) => state.paymentUser;
export default PaymentUserSlice.reducer;

export function fetchPaymentUsers(userState: UserState, addZeroValue: boolean) {
    return async (dispatch: Dispatch<any, any, any>) => {
        try {
            dispatch(init());
            const params = `page=${1}&size=${100}`
            const response = await getPaymentUserList(params,userState.currentSession?.accessToken!, userState.currentSession?.user?.email!);

            const newResponse = response.result.map((item) => {
                return {name: item.email, value: item.email};

            });
            if (addZeroValue){
                newResponse.unshift({ name: "Todos", value: "0" });

            }
            dispatch(paymentUsers(newResponse));
        } catch (error) {
            dispatch(failure({ message: 'Error' }))
        }
    }
}